import React from 'react';
import {Link} from 'react-router-dom';
import Wrapper from "./Wrapper";

const Breadcrumb = ({items, wrapper = true}) => {
    if (wrapper) {
        return (
            <nav className="py-2 text-gray-500 mb-2">
                <Wrapper>
                    {items.map((item, index) => (
                        <span key={index}>
                        {index > 0 && (<span className="mx-2">/</span>)}
                            {item.link ? (
                                <Link to={item.link} className="text-gray-700 underline">{item.title}</Link>
                            ) : (
                                <span>{item.title}</span>
                            )}
                </span>
                    ))}
                </Wrapper>
            </nav>
        );
    } else {
        return (
            <nav className="py-2 text-gray-500 mb-2">
                {items.map((item, index) => (
                    <span key={index}>
                        {index > 0 && (<span className="mx-2">/</span>)}
                        {item.link ? (
                            <Link to={item.link} className="text-gray-700 underline">{item.title}</Link>
                        ) : (
                            <span>{item.title}</span>
                        )}
                </span>
                ))}
            </nav>
        );
    }
};

export default Breadcrumb;
